// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3_5wr","footer":"ModalInfo_footer__2mj9L"};